import { render } from "./ImageIcon.vue?vue&type=template&id=ef4bb538"
import script from "./ImageIcon.vue?vue&type=script&lang=js"
export * from "./ImageIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__